import { BehaviorSubject } from "rxjs";

import { type APIProjectResponse } from "@/data_source/models/APIProjectResponse";

import { Store } from "./store";

export class ProjectSelectedStore extends Store<Partial<APIProjectResponse>> {
  protected _observable: BehaviorSubject<Partial<APIProjectResponse> | null>;
  private static instance?: ProjectSelectedStore;
  private constructor() {
    super();
    this._observable = new BehaviorSubject<Partial<APIProjectResponse> | null>(
      null
    );
  }
  static getInstance(): ProjectSelectedStore {
    ProjectSelectedStore.instance =
      ProjectSelectedStore.instance ?? new ProjectSelectedStore();
    return ProjectSelectedStore.instance;
  }
}
